import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { get } from 'lodash-es';
import Container from 'reactstrap/lib/Container';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Button from 'reactstrap/lib/Button';

import { CmsEntities } from 'client/data/models/cms';
import { getStaticImageUrl } from 'client/utils/image-helpers';

import { AspectRatioContainer } from 'site-modules/shared/components/aspect-ratio-container/aspect-ratio-container';
import { EvIncentivesCards } from 'site-modules/editorial/components/type-buying-guide/ev-incentives-cards/ev-incentives-cards';

export const IMAGE_SRC = getStaticImageUrl('/img/ev-incentives-tool/house-car-group.svg');

export function EvIncentivesModule({ content, className = null }) {
  const params = get(content, 'vehicles[0]');

  if (!params) {
    return null;
  }

  const { make, model } = params;
  const { title, summary } = content;
  const url = content.metadata('url').value();

  return (
    <div className={classnames('ev-incentives-module py-2', className)}>
      <Container>
        <Row className="flex-column-reverse flex-md-row">
          <Col xs={12} md={7}>
            {!!title && <h2 className="heading-3 mb-1">{title}</h2>}
            {summary && <div>{summary}</div>}
          </Col>
          <Col xs={12} md={5} className="ps-md-3 d-flex align-items-end mb-2_5 mb-md-0">
            <AspectRatioContainer aspectRatio="2:1" className="w-100">
              <img src={IMAGE_SRC} alt="" loading="lazy" />
            </AspectRatioContainer>
          </Col>
        </Row>
        <EvIncentivesCards incentivesConfig={{ makeSlug: make, modelSlug: model }} />
        <div className="text-center mt-2">
          <Button color="blue-50" href={url} className="py-0_75 px-2_5 size-16 text-transform-none fw-medium">
            Research More
          </Button>
        </div>
      </Container>
    </div>
  );
}

EvIncentivesModule.propTypes = {
  content: CmsEntities.Content.isRequired,
  className: PropTypes.string,
};
